import React from 'react';
import PageHeader from '@dashboard/components/PageHeader';

import HomepageSettingsForm from './components/HomepageSettingsForm';
import SettingsContainer from '@/dashboard/components/SettingsContainer';

const SettingsHomepage = () => {
  return (
    <div className="p-4 space-y-4">
      <PageHeader
        title="Homepage"
        description="Configure what visitors see when they visit your store's homepage."
      />

      <div className="mb-32">
        <SettingsContainer size="lg">
          <HomepageSettingsForm />
        </SettingsContainer>
      </div>
    </div>
  );
};

export default SettingsHomepage;
